var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadeyeimageProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_147_3718)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6121 32.8707V30.2697C38.6121 29.8704 38.284 29.5391 37.8847 29.5391C37.4854 29.5393 37.1639 29.8704 37.1639 30.2697V32.2181C36.5697 32.0071 36.0014 31.8674 35.5014 31.8674C33.0238 31.8674 28.8737 35.1276 28.4096 35.501C28.2342 35.6407 28.1367 35.8517 28.1367 36.0725C28.1367 36.2867 28.2342 36.498 28.4094 36.6309C28.8706 37.0045 33.0238 40.2647 35.5018 40.2647C36.0018 40.2647 36.5701 40.1315 37.1675 39.9238V41.8722C37.1675 42.2715 37.4923 42.5963 37.8916 42.5963C38.2909 42.5963 38.619 42.2715 38.619 41.8722V39.271C40.512 38.2742 42.2948 36.8714 42.5936 36.6311C42.7659 36.498 42.8663 36.2902 42.8663 36.0727C42.8663 35.8519 42.7656 35.6409 42.5936 35.5012C42.2948 35.2673 40.512 33.8612 38.6124 32.8707L38.6121 32.8707ZM35.5014 37.7352C34.5857 37.7352 33.8357 36.9884 33.8357 36.0725C33.8357 35.1535 34.5824 34.397 35.5014 34.397C36.4204 34.397 37.1671 35.1503 37.1671 36.0725C37.1639 36.9851 36.4171 37.7352 35.5014 37.7352ZM33.0464 34.1633C32.6373 34.6827 32.3905 35.3517 32.3905 36.0725C32.3905 36.79 32.6373 37.4429 33.0431 37.9753C31.9716 37.4038 30.8545 36.6571 30.0556 36.0725C30.8545 35.4849 31.9716 34.7283 33.0464 34.1633ZM38.6121 37.6085V34.5334C39.4693 35.0269 40.3039 35.6049 40.9435 36.0758C40.3072 36.537 39.4693 37.1085 38.6121 37.6085Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.308 25.1259C33.4475 25.2654 33.6328 25.3369 33.8212 25.3369C34.0062 25.3369 34.188 25.2686 34.331 25.1292L35.5 23.9602L36.669 25.1259C36.8087 25.2656 36.9938 25.3336 37.1788 25.3336C37.3639 25.3336 37.5489 25.2653 37.6917 25.1259C37.9741 24.8401 37.9741 24.3821 37.6917 24.1062L36.5227 22.9339L37.6917 21.7682C37.9741 21.4825 37.9741 21.0245 37.6917 20.742C37.4092 20.4595 36.9479 20.4563 36.6687 20.742L35.5 21.9044L34.331 20.7387C34.0485 20.453 33.5873 20.453 33.3081 20.7387C33.0223 21.0245 33.0223 21.4825 33.3081 21.765L34.4738 22.9307L33.3081 24.1062C33.0223 24.3854 33.0223 24.8401 33.3081 25.1258L33.308 25.1259Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1126 16.0371H27.8901C26.1594 16.0371 24.75 17.4528 24.75 19.1772V43.8234C24.75 45.5541 26.1594 46.9635 27.8901 46.9635H43.1133C44.844 46.9635 46.2534 45.5541 46.2534 43.8234V19.1772C46.2531 17.4528 44.844 16.0371 43.113 16.0371H43.1126ZM44.8012 43.8235C44.8012 44.7556 44.0479 45.5154 43.1126 45.5154L27.8901 45.5151C26.958 45.5151 26.1982 44.7553 26.1982 43.8232V19.177C26.1982 18.245 26.9547 17.4851 27.8901 17.4851H33.2349C31.1014 18.3784 29.6047 20.4824 29.6047 22.9309C29.6047 26.1845 32.248 28.8213 35.4983 28.8213C38.7519 28.8213 41.3953 26.1813 41.3953 22.9309C41.3953 20.4824 39.895 18.3784 37.765 17.4821H43.1099C44.0419 17.4821 44.7985 18.2419 44.7985 19.174L44.7982 43.8234L44.8012 43.8235ZM35.5013 18.4792C37.9563 18.4792 39.95 20.4828 39.95 22.9313C39.9498 25.386 37.9528 27.3765 35.5013 27.3765C33.0496 27.3765 31.0525 25.386 31.0525 22.931C31.0493 20.4826 33.0496 18.4792 35.5013 18.4792Z",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_147_3718",
    x: 0,
    y: 0,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_147_3718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_147_3718",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadeyeimageProgress);
export default __webpack_public_path__ + "static/media/upload eye image-progress.731534b813fb5c4872abd3a253e8329d.svg";
export { ForwardRef as ReactComponent };